module.exports = __webpack_public_path__ + "static/media/login.0f925c35.png";